import { MOBILE_PAGE, MOBILE_SIZE } from 'constants/values/params';
import * as actionTypes from 'store/actions/gifts/types';

export const initialState = {
  listOfGifts: {
    priceFilterCanBeSent: false,
    params: {
      page: 1,
      size: 12,
      mobilePage: MOBILE_PAGE,
      mobileSize: MOBILE_SIZE,
      brand: '',
      sort: ''
    },
    totalPages: 1,
    totalMobilePages: 1,
    totalElements: 0,
    results: {
      prices: [0, 0],
      list: [],
      mobileList: [],
      allElements: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: ''
    }
  },
  filters: {
    categories: [],
    sections: [],
    brands: []
  },
  productDetails: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {}
  },
  productsByRecommendations: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {
      categories: [],
      allProducts: []
    }
  },
  selectedCategory: {},
  showRecommendations: true,
  withRecommendations: true,
  dynamicRecommendation: {
    success: false,
    loading: false,
    error: false,
    empty: false,
    errorMessage: '',
    data: {
      rules: [],
      configurations: [],
      eventTypeId: ''
    }
  }
};

export const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case actionTypes.FETCH_GIFTS_PRODUCTS_BY_FILTERS:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          totalPages: initialState.listOfGifts.totalPages,
          totalElements: initialState.listOfGifts.totalElements,
          results: {
            ...state.listOfGifts.results,
            loading: false,
            success: false,
            error: false,
            errorMessage: ''
          }
        }
      };
    case actionTypes.FETCH_GIFTS_PRODUCTS_BY_FILTERS_SUCCESS: {
      const { totalPages, totalElements } = state.listOfGifts;
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          totalPages: payload.totalPages || totalPages,
          totalElements: payload.totalElements || totalElements,
          results: {
            ...state.listOfGifts.results,
            prices: payload.prices,
            list: payload.list,
            mobileList: payload.mobileList,
            allElements: payload.allElements,
            loading: false,
            success: true,
            error: false,
            errorMessage: ''
          }
        },
        filters: {
          ...state.filters,
          ...payload.filters
        }
      };
    }
    case actionTypes.FETCH_GIFTS_PRODUCTS_BY_FILTERS_FAILED:
    case actionTypes.FETCH_PRODUCTS_OF_SELECTED_CATEGORY_FAILED:
    case actionTypes.FETCH_PRODUCTS_DYNAMIC_CONFIG_FAILED:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          totalPages: initialState.listOfGifts.totalPages,
          totalElements: initialState.listOfGifts.totalElements,
          results: {
            ...state.listOfGifts.results,
            list: initialState.listOfGifts.results.list,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload
          }
        }
      };
    case actionTypes.SET_GIFTS_PRODUCTS_PARAMS:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          params: {
            ...state.listOfGifts.params,
            ...payload
          }
        }
      };
    case actionTypes.SET_GIFTS_PRODUCTS_PAGE: {
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          params: {
            ...state.listOfGifts.params,
            page: payload.page,
            mobilePage: payload.mobilePage
          }
        },
        showRecommendations: false
      };
    }
    case actionTypes.RESET_GIFTS_PRODUCTS: {
      return {
        ...state,
        listOfGifts: initialState.listOfGifts,
        showRecommendations: initialState.showRecommendations
      };
    }
    case actionTypes.PRICE_FILTER_CAN_BE_SENT: {
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          priceFilterCanBeSent: payload
        }
      };
    }
    case actionTypes.FETCH_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: {
          ...initialState.productDetails,
          loading: true
        }
      };
    case actionTypes.FETCH_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        productDetails: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload
        }
      };
    case actionTypes.FETCH_PRODUCT_DETAILS_FAILED:
      return {
        ...state,
        productDetails: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.productDetails.data
        }
      };
    case actionTypes.FETCH_PRODUCTS_BY_RECOMMENDATIONS:
      return {
        ...state,
        productsByRecommendations: {
          success: false,
          loading: false,
          error: false,
          errorMessage: '',
          data: {
            ...state.productsByRecommendations.data
          }
        },
        showRecommendations: true,
        selectedCategory: {}
      };
    case actionTypes.FETCH_PRODUCTS_BY_RECOMMENDATIONS_SUCCESS: {
      const { categories, allProducts, defaultCategory } = payload;
      return {
        ...state,
        productsByRecommendations: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: {
            ...state.productsByRecommendations.data,
            categories,
            allProducts
          }
        },
        showRecommendations: true,
        withRecommendations: true,
        selectedCategory: defaultCategory
      };
    }
    case actionTypes.FETCH_PRODUCTS_BY_RECOMMENDATIONS_FAILED:
      return {
        ...state,
        productsByRecommendations: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: {
            ...state.productsByRecommendations.data
          }
        },
        selectedCategory: {}
      };
    case actionTypes.FETCH_PRODUCTS_OF_SELECTED_CATEGORY:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          params: {
            ...state.listOfGifts.params,
            page: initialState.listOfGifts.params.page,
            size: initialState.listOfGifts.params.size
          },
          totalPages: initialState.listOfGifts.totalPages,
          totalElements: initialState.listOfGifts.totalElements,
          results: {
            ...initialState.listOfGifts.results,
            list: [],
            loading: true,
            success: false,
            error: false,
            errorMessage: ''
          }
        },
        showRecommendations: true
      };
    case actionTypes.FETCH_PRODUCTS_OF_SELECTED_CATEGORY_SUCCESS:
    case actionTypes.FETCH_PRODUCTS_DYNAMIC_CONFIG:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          totalPages: payload.totalPages || state.listOfGifts.totalPages,
          totalElements:
            payload.totalElements || state.listOfGifts.totalElements,
          results: {
            ...state.listOfGifts.results,
            list: payload.list || state.listOfGifts.results.list,
            mobileList:
              payload.mobileList || state.listOfGifts.results.mobileList,
            allElements:
              payload.allElements || state.listOfGifts.results.allElements,
            loading: false,
            success: true,
            error: false,
            errorMessage: ''
          }
        },
        showRecommendations: true
      };
    case actionTypes.SET_RECOMMENDED_CATEGORY:
      return {
        ...state,
        showRecommendations: true,
        selectedCategory: payload
      };
    case actionTypes.SET_SHOW_RECOMMENDATIONS:
      return {
        ...state,
        showRecommendations: payload
      };
    case actionTypes.SET_WITH_RECOMMENDATIONS:
      return {
        ...state,
        withRecommendations: payload
      };
    case actionTypes.CHANGE_RECOMMENDATION_PRODUCT_PAGE: {
      const { listOfGifts } = state;
      const { totalPages, totalMobilePages, totalElements } = listOfGifts;
      const { page, mobilePage } = listOfGifts.params;
      const { list, mobileList, allElements } = listOfGifts.results;
      return {
        ...state,
        listOfGifts: {
          ...listOfGifts,
          params: {
            ...listOfGifts.params,
            page: payload.page || page,
            mobilePage: payload.mobilePage || mobilePage
          },
          totalPages: payload.totalPages || totalPages,
          totalMobilePages: payload.totalMobilePages || totalMobilePages,
          totalElements: payload.totalElements || totalElements,
          results: {
            ...listOfGifts.results,
            list: payload.list || list,
            mobileList: payload.mobileList || mobileList,
            allElements: payload.allElements || allElements
          }
        }
      };
    }
    case actionTypes.CHANGE_RECOMMENDATION_PRODUCT_ORDER:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          results: {
            ...state.listOfGifts.results,
            list: action.payload.list,
            mobileList: action.payload.mobileList
          }
        }
      };
    case actionTypes.FETCH_DYNAMIC_CONFIGURATION:
      return {
        ...state,
        dynamicRecommendation: {
          ...initialState.dynamicRecommendation,
          loading: true
        },
        selectedCategory: initialState.selectedCategory
      };
    case actionTypes.FETCH_DYNAMIC_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        dynamicRecommendation: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
          empty: false
        }
      };
    }
    case actionTypes.FETCH_DYNAMIC_CONFIGURATION_EMPTY:
      return {
        ...state,
        dynamicRecommendation: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: initialState.dynamicRecommendation.data,
          empty: true
        }
      };
    case actionTypes.FETCH_DYNAMIC_CONFIGURATION_FAILED:
      return {
        ...state,
        dynamicRecommendation: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.dynamicRecommendation.data,
          empty: true
        }
      };
    case actionTypes.FETCH_PRODUCTS_DYNAMIC_CONFIG_SUCCESS:
      return {
        ...state,
        listOfGifts: {
          ...state.listOfGifts,
          params: {
            ...state.listOfGifts.params,
            page: 1
          },
          totalPages: payload.totalPages,
          totalElements: payload.totalElements,
          results: {
            ...state.listOfGifts.results,
            list: payload.list,
            mobileList: payload.mobileList,
            allElements: payload.allElements,
            loading: false,
            success: true,
            error: false,
            errorMessage: ''
          }
        }
      };
    case actionTypes.RESET_GIFTS:
      return initialState;
    default:
      return state;
  }
};
